/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  EXAM_CREATE,
  EXAM_GRADE_LIST,
  EXAM_LIST,
  EXAM_TYPE,
  QUESTION_LIST,
  REASONING_TYPE_LIST,
  SUBJECT_LIST,
  TOPIC_LIST,
  STUDENT_DATA,
  CREATE_AUTOGENERATE_EXAM_QUESTIONS,
  GET_EXAM_CREATION_DETAILS,
  SME_CREATE_EXAM_QP,
  ASSIGN_EXAM,
  STUDENT_DATA_DOWNLOAD_EXCEL,
  ASSIGN_VIEW_EXAM_REPORT_PERMISSION,
  GET_EXAM_BATCH,
  RESET_STUDENT_DOWNLOAD_REPORT,
  EXAM_TYPE_WISE_SUBJECT_LIST,
  STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL,
} from '../constants/action-types'
import { ExamData, ReasoninTypePayload } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'

const initialState: ExamData = {
  isLoading: false,
  errorMessage: '',
  examType: { data: [] },
  gradeList: { data: [] },
  subjectList: { data: [] },
  topicList: [],
  questionList: [],
  reasoningTypes: [],
  isCreateExamLoading: false,
  isUpcomingExamLoading: false,
  isSubjectListLoading: false,
  isOngoingExamLoading: false,
  isCompletedExamLoading: false,
  isQuestionListLoading: false,
  isAutogeneratedQuestionsLoading: false,
  isGetStudentLoading: false,
  isGetStudentDownloadExcelLoading: false,
  examList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  onGoingExamList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  completedExamList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  studentList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  studentListDownloadExcel: [],
  examDataById: {},
  eventKey: '',
  autogeneratedQuestionsList: null,
  examCreationDetails: null,
  examBatches: { student_count: 0, batches: [] },
  isGetStudentDownloadExcelQuestionWiseLoading: false,
  studentListDownloadExcelQuestionWise: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
}

const reducer = persistReducer(
  { storage, key: 'basecode-demo', whitelist: ['user'] },
  (state: ExamData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case EXAM_LIST.EXAM_LIST_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          isUpcomingExamLoading: true,
        }
      case EXAM_LIST.EXAM_LIST_SUCCESS:
        const exam: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          isUpcomingExamLoading: false,
          examList: exam,
        }

      case EXAM_LIST.EXAM_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
          isUpcomingExamLoading: false,
        }

      //create exam
      case EXAM_CREATE.EXAM_CREATE_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isCreateExamLoading: true,
        }
      case EXAM_CREATE.EXAM_CREATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isCreateExamLoading: false,
        }

      case EXAM_CREATE.EXAM_CREATE_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isCreateExamLoading: false,
        }

      //exam type
      case EXAM_TYPE.EXAM_TYPE_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case EXAM_TYPE.EXAM_TYPE_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          examType: action.payload as {
            data: { id: number; name: string }[]
          },
        }

      case EXAM_TYPE.EXAM_TYPE_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      //Grade List
      case EXAM_GRADE_LIST.EXAM_GRADE_LIST_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case EXAM_GRADE_LIST.EXAM_GRADE_LIST_SUCCESS:
        const grade: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          gradeList: grade,
        }

      case EXAM_GRADE_LIST.EXAM_GRADE_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      //SUBJECT_LIST
      case SUBJECT_LIST.SUBJECT_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          subjectList: {},
        }
      case SUBJECT_LIST.SUBJECT_LIST_SUCCESS:
        const sub: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          subjectList: sub,
        }

      case SUBJECT_LIST.SUBJECT_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      //TOPIC List
      case TOPIC_LIST.TOPIC_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          topicList: [],
        }
      case TOPIC_LIST.TOPIC_LIST_SUCCESS:
        const topic: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          topicList: topic,
        }

      case TOPIC_LIST.TOPIC_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      //Question List
      case QUESTION_LIST.QUESTION_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isQuestionListLoading: true,
          questionList: [],
        }
      case QUESTION_LIST.QUESTION_LIST_SUCCESS:
        const topics: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isQuestionListLoading: false,
          questionList: topics,
        }

      case QUESTION_LIST.QUESTION_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isQuestionListLoading: false,
        }

      // Reasing type list
      case REASONING_TYPE_LIST.REASONING_TYPE_LIST_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          reasoningTypes: [],
        }
      case REASONING_TYPE_LIST.REASONING_TYPE_LIST_SUCCESS:
        const reasoningTypes = (
          action.payload as unknown as ReasoninTypePayload
        ).data
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          reasoningTypes: reasoningTypes,
        }

      case REASONING_TYPE_LIST.REASONING_TYPE_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      // Exam List
      case EXAM_LIST.ONGOING_EXAM_LIST_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          isOngoingExamLoading: true,
        }
      case EXAM_LIST.ONGOING_EXAM_LIST_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          isOngoingExamLoading: false,
          onGoingExamList: action.payload,
        }

      case EXAM_LIST.ONGOING_EXAM_LIST_FAIL:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
          isOngoingExamLoading: false,
        }

      case EXAM_LIST.COMPLETED_EXAM_LIST_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          isCompletedExamLoading: true,
        }
      case EXAM_LIST.COMPLETED_EXAM_LIST_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          isCompletedExamLoading: false,
          completedExamList: action.payload,
        }

      case EXAM_LIST.COMPLETED_EXAM_LIST_FAIL:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
          isCompletedExamLoading: false,
        }
      //TAB KEY
      case EXAM_LIST.EXAM_TAB_KEY_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          eventKey: action.payload,
        }

      // Exam by id
      case EXAM_LIST.EXAM_LIST_BY_ID_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          examDataById: {},
        }
      case EXAM_LIST.EXAM_LIST_BY_ID_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          examDataById: action.payload,
        }

      case EXAM_LIST.EXAM_LIST_BY_ID_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      // STUDENT_LIST
      case STUDENT_DATA.STUDENT_DATA_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isGetStudentLoading: true,
          studentList: {
            count: 0,
            next: '',
            previous: '',
            results: [],
          },
        }
      case STUDENT_DATA.STUDENT_DATA_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isGetStudentLoading: false,
          studentList: action.payload,
        }

      case STUDENT_DATA.STUDENT_DATA_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isGetStudentLoading: false,
          studentList: {
            count: 0,
            next: '',
            previous: '',
            results: [],
          },
        }

      // STUDENT_LIST_DOWNLOAD_EXCEL
      case STUDENT_DATA_DOWNLOAD_EXCEL.STUDENT_DATA_DOWNLOAD_EXCEL_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isGetStudentDownloadExcelLoading: true,
          studentListDownloadExcel: {
            count: 0,
            next: '',
            previous: '',
            results: [],
          },
        }
      case STUDENT_DATA_DOWNLOAD_EXCEL.STUDENT_DATA_DOWNLOAD_EXCEL_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isGetStudentDownloadExcelLoading: false,
          studentListDownloadExcel: (action.payload as any) || [],
        }

      case STUDENT_DATA_DOWNLOAD_EXCEL.STUDENT_DATA_DOWNLOAD_EXCEL_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isGetStudentDownloadExcelLoading: false,
          studentListDownloadExcel: [],
        }

      // STUDENT_LIST_DOWNLOAD_EXCEL_QUESTION_WISE
      case STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL.STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isGetStudentDownloadExcelQuestionWiseLoading: true,
          studentListDownloadExcelQuestionWise: {
            count: 0,
            next: '',
            previous: '',
            results: [],
          },
        }
      case STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL.STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isGetStudentDownloadExcelQuestionWiseLoading: false,
          studentListDownloadExcelQuestionWise: (action.payload as any) || [],
        }

      case STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL.STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isGetStudentDownloadExcelQuestionWiseLoading: false,
          studentListDownloadExcelQuestionWise: [],
        }

      case RESET_STUDENT_DOWNLOAD_REPORT:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          studentListDownloadExcel: [],
          studentListDownloadExcelQuestionWise: [],
        }

      case CREATE_AUTOGENERATE_EXAM_QUESTIONS.CREATE_AUTOGENERATE_EXAM_QUESTIONS_INITLIZATION:
        return {
          ...state,
          isLoading: true,
          isAutogeneratedQuestionsLoading: true,
          autogeneratedQuestionsList: null,
        }

      case CREATE_AUTOGENERATE_EXAM_QUESTIONS.CREATE_AUTOGENERATE_EXAM_QUESTIONS_SUCCESS:
        const questionList: any = action.payload
        return {
          ...state,
          isLoading: false,
          isAutogeneratedQuestionsLoading: false,
          autogeneratedQuestionsList: questionList,
        }
      case CREATE_AUTOGENERATE_EXAM_QUESTIONS.CREATE_AUTOGENERATE_EXAM_QUESTIONS_ERROR:
        return {
          ...state,
          isLoading: false,
          isAutogeneratedQuestionsLoading: false,
        }

      case GET_EXAM_CREATION_DETAILS.GET_EXAM_CREATION_DETAILS_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
          examCreationDetails: null,
        }
      case GET_EXAM_CREATION_DETAILS.GET_EXAM_CREATION_DETAILS_SUCCESS:
        const payload: any = action.payload
        return {
          ...state,
          isLoading: false,
          examCreationDetails: payload,
        }
      case GET_EXAM_CREATION_DETAILS.GET_EXAM_CREATION_DETAILS_ERROR:
        return {
          ...state,
          isLoading: false,
        }

      case SME_CREATE_EXAM_QP.SME_CREATE_EXAM_QP_INITIALIZATION:
        return {
          ...state,
          isCreateExamLoading: true,
        }
      case SME_CREATE_EXAM_QP.SME_CREATE_EXAM_QP_SUCCESS:
        return {
          ...state,
          isCreateExamLoading: false,
        }
      case SME_CREATE_EXAM_QP.SME_CREATE_EXAM_QP_ERROR:
        return {
          ...state,
          isCreateExamLoading: false,
        }
      case ASSIGN_EXAM.ASSIGN_EXAM_INITLIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case ASSIGN_EXAM.ASSIGN_EXAM_ERROR:
        return {
          ...state,
          isLoading: false,
        }
      case ASSIGN_EXAM.ASSIGN_EXAM_SUCCESS:
        return {
          ...state,
          isLoading: false,
        }
      case ASSIGN_VIEW_EXAM_REPORT_PERMISSION.GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case ASSIGN_VIEW_EXAM_REPORT_PERMISSION.GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_SUCCESS:
        return {
          ...state,
          isLoading: false,
        }
      case ASSIGN_VIEW_EXAM_REPORT_PERMISSION.GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_ERROR:
        return {
          ...state,
          isLoading: false,
        }

      case GET_EXAM_BATCH.GET_EXAM_BATCH_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }

      case GET_EXAM_BATCH.GET_EXAM_BATCH_FAILED:
        return {
          ...state,
          isLoading: false,
        }

      case GET_EXAM_BATCH.GET_EXAM_BATCH_SUCCESS:
        const examBatches = action?.payload as any
        return {
          ...state,
          isLoading: false,
          examBatches,
        }
      case EXAM_TYPE_WISE_SUBJECT_LIST.EXAM_TYPE_WISE_SUBJECT_LIST_INITIALIZATION:
        return {
          ...state,
          isSubjectListLoading: true,
          subjectList: { data: [] },
        }
      case EXAM_TYPE_WISE_SUBJECT_LIST.EXAM_TYPE_WISE_SUBJECT_LIST_ERORR:
        return {
          ...state,
          isSubjectListLoading: false,
        }
      case EXAM_TYPE_WISE_SUBJECT_LIST.EXAM_TYPE_WISE_SUBJECT_LIST_SUCCESS:
        const subjectList: any = action?.payload
        return {
          ...state,
          isSubjectListLoading: false,
          subjectList,
        }

      default:
        return state
    }
  }
)

export default reducer
